import { Select } from 'antd';
import { InputDataVersionInfo, InputDataVersionType } from './types';
import styled, { createGlobalStyle } from 'styled-components';
import {
  colorNeutral,
  colorNeutralBg,
  colorNeutralBorder,
  colorSuccessBg,
  colorSuccessBorder,
  colorWarningBg,
  colorWarningBorder,
} from '@atlas-frontend/design-tokens';
import { useCallback } from 'react';
import { useQueryParams } from '@atlas-frontend/sdk';

export interface InputDataStatusSelectProps {
  disabled: boolean;
  onChange: (value: InputDataVersionType) => void;
  versionData: InputDataVersionInfo;
}

export function InputDataStatusSelect({
  disabled,
  onChange,
  versionData: { setVersion, version, versionOptions },
}: InputDataStatusSelectProps) {
  const [, setQueryParams] = useQueryParams();
  const changeStatus = useCallback(
    (value: InputDataVersionType) => {
      if (value !== 'output') {
        setVersion(value);
        setQueryParams({ outputDataVersionId: undefined });
      }
      onChange(value);
    },
    [onChange, setQueryParams, setVersion],
  );
  return (
    <>
      <InputDataStatusGlobalStyle />
      <SelectWrapper
        id="input-data-status-select"
        disabled={disabled || (versionOptions?.length ?? 0) === 0}
        onSelect={changeStatus}
        options={versionOptions}
        styles={{
          popup: { root: { width: 'max-content' } },
        }}
        classNames={{ popup: { root: 'input-data-status-popup' } }}
        style={{ width: '160px' }}
        value={version}
      />
    </>
  );
}

const InputDataStatusGlobalStyle = createGlobalStyle`
  .input-data-status-popup .ant-select-item {
    text-transform: uppercase;
  }

  .input-data-status-popup .ant-select-item.inUse {
    background-color: ${colorSuccessBg} !important;
  }
  .input-data-status-popup .ant-select-item.inUse.ant-select-item-option-active {
    background-color: ${colorSuccessBorder} !important;
  }

  .input-data-status-popup .ant-select-item.pending {
    background-color: ${colorWarningBg} !important;
  }
  .input-data-status-popup .ant-select-item.pending.ant-select-item-option-active {
    background-color: ${colorWarningBorder} !important;
  }

  .input-data-status-popup .ant-select-item.outputBased {
    background-color: ${colorNeutralBg} !important;
  }
  .input-data-status-popup .ant-select-item.outputBased.ant-select-item-option-active {
    background-color: ${colorNeutralBorder} !important;
  }
`;

const SelectWrapper = styled(Select<any, any>)`
  margin: auto 0;

  .ant-select-arrow {
    inset-inline-end: 8px;
  }

  :has(.inUse) {
    background-color: ${colorSuccessBg} !important;
  }
  :has(.pending) {
    background-color: ${colorWarningBg} !important;
  }
  :has(.outputBased) {
    background-color: ${colorNeutralBg} !important;
    color: ${colorNeutral} !important;
  }

  .ant-select-selector {
    padding-inline: 6px !important;
    width: 100%;

    .ant-select-selection-item {
      font-weight: 500;
      padding-inline-end: 24px;
      text-transform: uppercase;
    }
  }
`;
